import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAdmin } from "../../context/AdminContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAdmin();
  const [form, setForm]       = useState({ email: "", password: "" });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:5001"}/api/admin/login`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || "Login failed.");
        return;
      }
      login(data.token, data.user);
      navigate("/admin/dashboard");
    } catch {
      setError("Could not connect to server.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
        <div className="w-full max-w-md">

          {/* Logo */}
          <div className="text-center mb-8">
  <div className="inline-flex flex-col items-center">
    <span
      className="text-white font-bold tracking-[0.18em] uppercase text-lg"
      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
    >
      Sagar Lifestyle NY
    </span>
    <div className="w-full flex items-center gap-2 my-1">
      <div className="flex-1 h-px bg-amber-600" />
      <span className="text-amber-600 text-[9px] font-bold tracking-[0.3em] uppercase">LLC</span>
      <div className="flex-1 h-px bg-amber-600" />
    </div>
  </div>
  <p className="text-gray-400 mt-2 text-sm">Admin Dashboard</p>
</div>

          {/* Card */}
          <div className="bg-gray-900 rounded-2xl p-8 shadow-2xl border border-gray-800">
            <h2 className="text-xl font-semibold text-white mb-6">Sign in to continue</h2>

            {error && (
              <div className="bg-rose-500/10 border border-rose-500/30 text-rose-400 text-sm rounded-lg px-4 py-3 mb-5">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Email</label>
                <input
                  type="email"
                  required
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-rose-500 transition"
                  placeholder="admin@sagarfashion.com"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">Password</label>
                <input
                  type="password"
                  required
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-rose-500 transition"
                  placeholder="••••••••"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-rose-600 hover:bg-rose-500 disabled:opacity-50 text-white font-semibold rounded-lg py-2.5 text-sm transition"
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-center gap-4 mt-6">
            <a href="/" className="flex items-center gap-1.5 text-gray-500 hover:text-white text-xs transition-colors">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back to Store
            </a>
            <span className="text-gray-700">·</span>
            <p className="text-gray-600 text-xs">
  Sagar Lifestyle NY LLC © {new Date().getFullYear()}
</p>
          </div>

        </div>
      </div>
    </>
  );
}